import { useTranslations } from 'next-intl';
import { StyledIconTooltip, StyledProductLabelSplash } from '@molecules/ProductLabelSplash/ProductLabelSplash.styles';
import React from 'react';
import Link from '@atoms/Link/Link';
import paths from '@constants/paths';
import Info from '@icons/info.svg';
import { dateToWeekDayDaysAndMonths } from '@helpers/date';

export type LabelSplashType =
  | 'mixmatch'
  | 'news'
  | 'medical'
  | 'age_18'
  | 'bargain'
  | 'segmented'
  | 'ecological'
  | 'bomb';

interface ProductLabelSplashProps {
  type: LabelSplashType;
  blockElement?: boolean;
  isPromotionUsed?: boolean;
  validUntil?: number;
}

const ProductLabelSplash = ({ type, blockElement = false, isPromotionUsed, validUntil }: ProductLabelSplashProps) => {
  const t = useTranslations('product');
  const tCommon = useTranslations('common');

  // Do not render the splash at all for 'bomb' if no validUntil is provided
  if (type === 'bomb' && !validUntil) return null;

  const labelKeys: Record<LabelSplashType, `${LabelSplashType}.label`> = {
    mixmatch: 'mixmatch.label',
    news: 'news.label',
    medical: 'medical.label',
    age_18: 'age_18.label',
    bargain: 'bargain.label',
    segmented: 'segmented.label',
    ecological: 'ecological.label',
    bomb: 'bomb.label',
  };

  return (
    <StyledProductLabelSplash $type={type} $blockElement={blockElement}>
      {t(labelKeys[type])}
      {type === 'bomb' && validUntil && ` ${dateToWeekDayDaysAndMonths(validUntil)}`}
      {type === 'segmented' && (
        <StyledIconTooltip
          variant="medium"
          iconProps={{ svg: Info, size: 12, 'aria-label': tCommon('aria.infoIcon') }}
          content={
            <>
              {t.rich('tooltipPersonalText', {
                link: (chunks) => (
                  <Link key="link" href={paths.ARTICLE.PERSONALIZATION} variant="secondary">
                    {chunks}
                  </Link>
                ),
              })}
            </>
          }
          position="bottom"
          openOnClick
          disabled={isPromotionUsed}
        />
      )}
    </StyledProductLabelSplash>
  );
};

export default ProductLabelSplash;
